import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";
import { getDummyText } from "../../utils";

export default {
    title: "Utility/Text Lines Limit",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    component: "ux-iws-text-lines-limit",
    args: {
        collapse: "false",
        expand: "false",
        nestedElementSelector: "false",
        readMoreText: "undefined",
        textLines: "",
        textLinesL: "1",
        textLinesM: "1",
        textLinesS: "1",
        textLinesXl: "1",
    },
    argTypes: {
        collapse: {
            control: "boolean",
        },
        expand: {
            control: "boolean",
        },
        nestedElementSelector: {
            control: "boolean | string",
        },
        readMoreText: {
            control: "string",
        },
        textLines: {
            control: "number",
        },
        textLinesL: {
            control: "number",
        },
        textLinesM: {
            control: "number",
        },
        textLinesS: {
            control: "number",
        },
        textLinesXl: {
            control: "number",
        },
    },
};

const Template = ({ textLinesL, textLinesM, textLinesS, textLinesXl }) => html`
    <ux-iws-text-lines-limit
        text-lines-l="${textLinesL}"
        text-lines-m="${textLinesM}"
        text-lines-s="${textLinesS}"
        text-lines-xl="${textLinesXl}"
    >
        <p>${getDummyText(300)}</p>
    </ux-iws-text-lines-limit>
`;

export const Default = Template.bind({});

const TemplateNestedSelector = ({
    textLinesL,
    textLinesM,
    textLinesS,
    textLinesXl,
}) => html`
    <ux-iws-text-lines-limit
        text-lines-l="${textLinesL}"
        text-lines-m="${textLinesM}"
        text-lines-s="${textLinesS}"
        text-lines-xl="${textLinesXl}"
    >
        <span class="ux-u-text-bold"> ${getDummyText(300)} </span>
        <span class="ux-text-normal"> ${getDummyText(300)} </span>
    </ux-iws-text-lines-limit>
`;

export const Nested = TemplateNestedSelector.bind({});
Nested.args = {
    nestedElementSelector: "ux-text-normal",
};

const TemplateExpand = ({ textLines, expand }) => html`
    <ux-iws-text-lines-limit text-lines="${textLines}" expand="${expand}">
        <span class="ux-u-text-bold"> ${getDummyText(50)} </span>
        <span class="ux-text-normal"> ${getDummyText(300)} </span>
    </ux-iws-text-lines-limit>
`;

export const Expand = TemplateExpand.bind({});
Expand.args = {
    textLines: "2",
    expand: "true",
};

const TemplateCollapse = ({ textLines, expand, collapse }) => html`
    <div
        style="padding: 30px; height: 230px; box-shadow: 0 7px 22px rgba(19, 19, 19, 0.08); margin-bottom: 30px; display: flex; flex-direction: column;"
    >
        <ux-iws-text-lines-limit text-lines="${textLines}" expand="${collapse}">
            <h3 class="ux-text-headline ux-text-headline--big ux-u-mx-zero">
                A short title
            </h3>
        </ux-iws-text-lines-limit>
        <ux-iws-text-lines-limit text-lines="${textLines}" expand="${expand}">
            <p style="">
                Sed ut perspiciatis unde omnis iste natus error sit voluptatem
                accusantium doloremque laudantium, totam rem aperiam, eaque ipsa
                quae ab illo inventore veritatis et quasi architecto beatae
                vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia
                voluptas sit aspernatur aut odit aut fugit, sed quia
                consequuntur magni dolores eos qui ratione voluptatem sequi
                nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor
                sit amet consectetur, adipisci velit, sed quia non numquam eius
                modi tempora incidunt ut labore et dolore magnam aliquam quaerat
                voluptatem. Ut enim ad minima veniam, quis nostrum exerci
                tationem ullam corporis suscipit laboriosam, nisi ut aliquid ex
                ea commodi consequatur?
            </p>
        </ux-iws-text-lines-limit>
    </div>
    <div
        style="padding: 30px; height: 230px; box-shadow: 0 7px 22px rgba(19, 19, 19, 0.08); display: flex; flex-direction: column;"
    >
        <ux-iws-text-lines-limit text-lines="${textLines}" expand="${collapse}">
            <h3 class="ux-text-headline ux-text-headline--big ux-u-mx-zero">
                A very long title sed ut perspiciatis unde omnis iste natus
                error sit voluptatem accusantium doloremque laudantium, totam
                rem aperiam, eaque ipsa quae ab illo inventore veritatis et
                quasi architecto beatae vitae dicta sunt explicabo. Nemo enim
                ipsam voluptatem quia voluptas sit aspernatur
            </h3>
        </ux-iws-text-lines-limit>
        <ux-iws-text-lines-limit text-lines="${textLines}" expand="${expand}">
            <p>
                Sed ut perspiciatis unde omnis iste natus error sit voluptatem
                accusantium doloremque laudantium, totam rem aperiam, eaque ipsa
                quae ab illo inventore veritatis et quasi architecto beatae
                vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia
                voluptas sit aspernatur aut odit aut fugit, sed quia
                consequuntur magni dolores eos qui ratione voluptatem sequi
                nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor
                sit amet consectetur, adipisci velit, sed quia non numquam eius
                modi tempora incidunt ut labore et dolore magnam aliquam quaerat
                voluptatem. Ut enim ad minima veniam, quis nostrum exerci
                tationem ullam corporis suscipit laboriosam, nisi ut aliquid ex
                ea commodi consequatur?
            </p>
        </ux-iws-text-lines-limit>
    </div>
`;

export const Collapse = TemplateCollapse.bind({});
Collapse.args = {
    textLines: "2",
    expand: "true",
    collapse: "true",
};

const TemplateReadMore = ({ textLines, readMoreText }) => html`
    <ux-iws-text-lines-limit
        text-lines="${textLines}"
        read-more-text="${readMoreText}"
    >
        <div>
            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
            nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam
            erat, sed diam voluptua. At vero eos et accusam et justo duo dolores
            et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est.
            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
            nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam
            erat, sed diam voluptua. At vero eos et accusam et.
        </div>
    </ux-iws-text-lines-limit>
`;

export const ReadMore = TemplateReadMore.bind({});
ReadMore.args = {
    textLines: "2",
    readMoreText: "Read More",
};

const items = Array.from(Array(10).keys());
export const InsideTabs = () => html` <ux-tab-container>
    <ux-tab name="Tab 0" tab-id="tab-0"></ux-tab>
    <ux-tab name="Tab 1" tab-id="tab-1">
        <div style="max-width: 400px;">
            ${items.map(
                () => html`
                    <ux-iws-text-lines-limit text-lines="2">
                        <p>${getDummyText(600)}</p>
                    </ux-iws-text-lines-limit>
                `
            )}
        </div>
    </ux-tab>
    <ux-tab name="Tab 2" tab-id="tab-2">
        <div style="max-width: 400px;">
            ${items.map(
                () => html`
                    <ux-iws-text-lines-limit
                        text-lines="2"
                        read-more-text="more"
                    >
                        <p>${getDummyText(600)}</p>
                    </ux-iws-text-lines-limit>
                `
            )}
        </div>
    </ux-tab>
</ux-tab-container>`;
